import LivechatHandler from "./livechat_handler.js";
import Zajax from "./modules/zajax.js";
import Endpoint from "./modules/endpoint.js";

class SuperAGILiveChat {
  constructor() {
    this.initialized = false;
    this.workspaceId = null;
    this.userData = {};
    this.conversationStarted = false;
  }

  init(encryptedConfig) {
    if (this.initialized) {
      return this;
    }

    try {
      console.log("Widget init called with:", encryptedConfig);
      const config = JSON.parse(atob(encryptedConfig));
      console.log("Decoded config:", config);
      
      this.workspaceId = parseInt(config.w);
      this.userId = config.u ? config.u.toString() : null;
      
      if (config.e) {
        window.WIDGET_ENV = config.e;
      }

      if (this.userId) {
        localStorage.setItem(`livechat_external_id_${this.workspaceId}`, this.userId);
      }

      console.log("Calling LivechatHandler.init with workspace:", this.workspaceId);
      LivechatHandler.init(this.workspaceId);
      this.initialized = true;
    } catch (error) {
      console.error("Invalid configuration", error);
    }

    return this;
  }

  async setUserData(userData) {
    if (!this.initialized) {
      console.error("SuperAGI LiveChat not initialized. Call init() first.");
      return;
    }

    this.userData = {
      ...this.userData,
      ...userData
    };

    this._storeUserData(userData);

    return this;
  }

  show() {
    const widget = document.getElementById("livechat_widget");
    const launcher = document.getElementById("livechat_widget_launcher");
    
    if (widget) widget.style.display = "block";
    if (launcher) launcher.style.display = "none";
    
    return this;
  }

  hide() {
    const widget = document.getElementById("livechat_widget");
    const launcher = document.getElementById("livechat_widget_launcher");
    
    if (widget) widget.style.display = "none";
    if (launcher) launcher.style.display = "flex";
    
    return this;
  }

  shutdown() {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.includes(`livechat_`) && key.includes(`_${this.workspaceId}`)) {
        localStorage.removeItem(key);
      }
    });

    const widget = document.getElementById("livechat_widget");
    const launcher = document.getElementById("livechat_widget_launcher");
    
    if (widget) widget.remove();
    if (launcher) launcher.remove();

    this.initialized = false;
    this.workspaceId = null;
    this.userData = {};
    this.conversationStarted = false;

    return this;
  }

  async _startConversation(message) {
    if (this.conversationStarted) return;
    this.conversationStarted = true;
  }

  _storeUserData(userData) {
    if (userData.email) {
      localStorage.setItem(`livechat_user_email_${this.workspaceId}`, userData.email);
    }
    if (userData.name) {
      localStorage.setItem(`livechat_user_name_${this.workspaceId}`, userData.name);
    }
  }

  sendMessage(message) {
    if (!this.initialized) {
      console.error("SuperAGI LiveChat not initialized. Call init() first.");
      return;
    }

    this._startConversation(message);

    const textarea = document.getElementById("widget-message-livechat");
    if (textarea) {
      textarea.value = message;
      const event = new KeyboardEvent('keydown', {
        key: 'Enter',
        keyCode: 13,
        which: 13,
        shiftKey: false
      });
      textarea.dispatchEvent(event);
    }

    return this;
  }

  isInitialized() {
    return this.initialized;
  }

  getUserData() {
    return this.userData;
  }
}

const instance = new SuperAGILiveChat();
window.SuperAGILiveChat = instance;

export default instance;
